import React from 'react';
import './chatbot.scss';
import { connect } from 'react-redux';
import Settings from 'services/settings.service';
const userAgentString = navigator.userAgent;

class ChatComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      app: {
        appURL: Settings.REACT_APP_CHAT_WIDGET_SRC,
        chatIcon: 'https://bot.lebara.sa/images/open.png',
        chatLogo: 'https://bot.lebara.sa/images/open.png',
        appHead: 'Lebara',
        appDesc: 'Lebara',
        apphideHead: '.b-agent-demo_header',
      },
      themeColor: {
        HeaderbgColor: '#1d469e',
        chatBg: '#fff',
        borderColor: '1px solid #cecece',
      },
      chatToggle: false,
    };

    this.toggleChat = this.toggleChat.bind(this);
  }

  loadScript() {
    const botId = `${this.props.configs?.bot_id ?? 'x1755856634111'}`;

    // Define ymConfig
    window.ymConfig = {
      bot: botId,
      host: 'https://r7.cloud.yellow.ai',
      payload: { language: this.props.lang ?? 'en' },
    };

    // Load the YellowMessenger script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.setAttribute('nonce', '43215e85-7f87-4af2-adc9-5ee9c5b0ef5e');
    script.src =
      'https://cdn.yellowmessenger.com/plugin/widget-v2/latest/dist/main.min.js';

    script.onload = () => {
      if (typeof window.YellowMessenger === 'function') {
        window.YellowMessenger('reattach_activator');
        window.YellowMessenger('update', window.ymConfig);
      }
    };

    script.onerror = () => {
      console.error('Failed to load YellowMessenger script.');
    };

    document.body.appendChild(script);
  }
  componentDidMount() {
    this.loadScript();
    this.interval = setInterval(() => {
      const chatIcon = document.querySelector('#ico');

      if (chatIcon) {
        chatIcon.classList.toggle('active');
      }
    }, 3000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  toggleChat(e) {
    e.preventDefault();
    this.setState({ chatToggle: !this.state.chatToggle });
  }

  render() {
    return null;
  }
}
const mapStateToProps = (state) => {
  return {
    configs: state.layout.configs,
    lang: state.layout.iso,
  };
};
export default connect(mapStateToProps)(ChatComponent);
